import { TradingModal } from '@trading-ui/core';

import type { CreateCompanyUserPayload, Plant, User } from '@/interfaces';

import CompanyUserForm from '../forms/CompanyUserForm';

import useUserForm from '../../hooks/utils/useUserForm';

import { FormUtils } from '../../utils/form.utils';

type Props = {
  selectedUser: User;
  setSelectedUser: (user: User | null) => void;
  companyPlants: Plant[];
  handleUpdateUser: (id: number, payload: Partial<CreateCompanyUserPayload>) => Promise<void> | void;
  companyId: number;
};

export default function UpdateCompanyUsersModal({
  selectedUser,
  setSelectedUser,
  companyPlants,
  handleUpdateUser,
  companyId,
}: Props) {
  const { form, isSubmitting, errors, updateField, updatePlants, handleSubmit, updateRole } = useUserForm({
    initialState: FormUtils.getInitialStateUser(selectedUser),
    onSubmit: async (payload) => {
      await handleUpdateUser(selectedUser.id, payload);
      setSelectedUser(null);
    },
    companyId,
  });

  return (
    <TradingModal
      titleText="Update User"
      bodyText={
        <CompanyUserForm
          form={form}
          isSubmitting={isSubmitting}
          errors={errors}
          companyPlants={companyPlants}
          updateField={updateField}
          updatePlants={updatePlants}
          updateRole={updateRole}
          handleSubmit={handleSubmit}
          type="update"
        />
      }
      open
      onClose={() => setSelectedUser(null)}
      styleModal={{
        minHeight: '35%',
        overflow: 'visible',
      }}
    />
  );
}
